'use client'

import { IS_PROD } from '@/core/constants/is-prod'
import { envService } from '@/core/services/env'
import { useCookiesStore } from '@/core/store/cookies'
import Script from 'next/script'

export const GoogleTagManager = () => {
  const gtmId = envService.get('GOOGLE_TRACKING_ID')
  const { cookiesConsented } = useCookiesStore()

  if (!gtmId || !IS_PROD || !cookiesConsented) return null

  return (
    <>
      <Script
        id='gtm'
        strategy='afterInteractive'
        dangerouslySetInnerHTML={{
          __html: `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${gtmId}');
        `,
        }}
      />

      <noscript
        dangerouslySetInnerHTML={{
          __html: `
            <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>
          `,
        }}
      />
    </>
  )
}
